// src/api/modules/FirstPickupApi.js
import Methods from "../methods";
import {formatDate} from "../../util/date-util";

const searchPickups = (context, payload) => {
  const {filters, page, size} = payload;
  const url = `api/first-pickups/search?page=${page}&size=${size}`;
  return Methods.doPost(context, url, filters, null);
};

const firstPickupList = (context, payload) => {
  const statusParam = payload && payload.status ? `?status=${payload.status}` : '';
  const url = `api/first-pickups${statusParam}`;
  return Methods.doGet(context, url, null);
};

const changeStatusPickup = (context, payload) => {
  const url = `api/first-pickups/${payload.action}`;
  return Methods.doPut(payload.context, url, payload.pickup, null);
};

const downloadPickupOrderPdf = (context, id) => {
  const url = `api/first-pickups/generate-order/${id}`;

  const newDate = formatDate(new Date());
  const fileName = `Orden_recojo_materiales` + "_" + newDate + ".pdf";
  return Methods.doPostDonwload(context, url, {}, fileName, null);
};

/**
 * payload - Contiene filters y type ("pdf" | "xlsx" | "detail")
 */
const exportReport = (context, payload) => {
  const {filters, type} = payload;
  let url, ext, nameBase;

  const newDate = formatDate(new Date());
  switch (type) {
    case "pdf":
      url = "api/report/first-pickup/pdf";
      ext = "pdf";
      nameBase = "Reporte_recojo_materiales";
      break;
    case "xlsx":
      url = "api/report/first-pickup/excel";
      ext = "xlsx";
      nameBase = "Reporte_recojo_materiales";
      break;
    default:
      url = "api/report/first-pickup/excel-detail";
      ext = "xlsx";
      nameBase = "Reporte_recojo_materiales_detallado";
      break;
  }

  const fileName = nameBase + "_" + newDate;
  filters.extExport = ext;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

export default {
  searchPickups,
  firstPickupList,
  changeStatusPickup,
  downloadPickupOrderPdf,
  exportReport,
};



// WEBPACK FOOTER //
// ./src/api/modules/FirstPickupApi.js